import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { InitialState, InstitutionEmpty } from 'domain/models/representantive'
import {
  Institution,
  ReadRepresentativeAndStudentsQueryResponse,
} from 'domain/entities/representative'
import { selectedInstitutionKey } from 'presentation/constant/localStorageKeys'
import { RootState } from 'presentation/redux/reducers'

const selectedInstitutionFromSessionStorage: Institution =
  JSON.parse(sessionStorage.getItem(selectedInstitutionKey) as string) || InstitutionEmpty

const initialState: InitialState = {
  error: null,
  isLoading: false,
  institutions: [],
  selectedInstitution: selectedInstitutionFromSessionStorage,
  representative: null,
  students: [],
  isLoadingUpdate: false,
}
export const representativeSlice = createSlice({
  name: 'representative',
  initialState,
  reducers: {
    getInstitutionsByRepresentativeStart: (state: InitialState) => {
      state.isLoading = true
      state.isLoadingUpdate = false
      state.error = null
    },
    getInstitutionsByRepresentativeSuccess: (
      state: InitialState,
      action: PayloadAction<Institution[]>,
    ) => {
      state.isLoading = false
      state.institutions = action.payload
    },
    getInstitutionsByRepresentativeError: (state: InitialState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    selectedRepresentativeInstitution: (
      state: InitialState,
      action: PayloadAction<Institution>,
    ) => {
      state.selectedInstitution = action.payload
    },
    deleteSelectedRepresentativeInstitution: (state: InitialState) => {
      state.isLoading = false
      state.error = null
      state.selectedInstitution = InstitutionEmpty
      state.institutions = []
      state.isLoadingUpdate = false
    },
    getGetRepresentativeStart: (state: InitialState) => {
      state.isLoading = true
      state.error = null
      state.isLoadingUpdate = false
    },
    getGetRepresentativeSuccess: (
      state: InitialState,
      action: PayloadAction<ReadRepresentativeAndStudentsQueryResponse>,
    ) => {
      state.isLoading = false
      state.representative = action.payload.representative
      state.students = action.payload.students
    },
    getGetRepresentativeError: (state: InitialState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    updateRoleRepresentativeStart: (state: InitialState) => {
      state.isLoading = true
      state.error = null
      state.isLoadingUpdate = false
    },
    updateRoleRepresentativeSuccess: (state: InitialState) => {
      state.isLoading = false
    },
    updateRoleRepresentativeError: (state: InitialState, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
    updateRepresentativeStart: (state: InitialState) => {
      state.isLoadingUpdate = true
      state.isLoading = false
      state.error = null
    },
    updateRepresentativeSuccess: (state: InitialState) => {
      state.isLoadingUpdate = false
      state.isLoading = false
    },
    updateRepresentativeError: (state: InitialState, action: PayloadAction<string>) => {
      state.isLoadingUpdate = false
      state.error = action.payload
    },
    clearRepresentative: (state: InitialState) => {
      state.representative = null
      state.students = []
    },
  },
})

export const representativeState = (state: RootState) => state.representative
export const {
  getInstitutionsByRepresentativeStart,
  getInstitutionsByRepresentativeSuccess,
  getInstitutionsByRepresentativeError,
  selectedRepresentativeInstitution,
  getGetRepresentativeStart,
  getGetRepresentativeSuccess,
  getGetRepresentativeError,
  updateRoleRepresentativeStart,
  updateRoleRepresentativeSuccess,
  updateRoleRepresentativeError,
  updateRepresentativeStart,
  updateRepresentativeSuccess,
  updateRepresentativeError,
  deleteSelectedRepresentativeInstitution,
  clearRepresentative,
} = representativeSlice.actions

export default representativeSlice.reducer
